import request from '@/config/axios'

export const getCircleCategoryPage = (params: any) =>
  request.get({ url: '/bosscircle/circle-category/page', params })
export const createCircleCategory = (data: any) =>
  request.post({ url: '/bosscircle/circle-category/create', data })
export const updateCircleCategory = (data: any) =>
  request.put({ url: '/bosscircle/circle-category/update', data })
export const deleteCircleCategory = (params: any) =>
  request.delete({ url: '/bosscircle/circle-category/delete', params })
